import Controller from '@ember/controller';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

export default class IndexController extends Controller {
  queryParams = ['search', 'page'];
  search = '';
  page = 1;
  type = null;

  isShowingSendTestEventModal = false;

  @action
  toggleSendTestEventModal() {
    this.toggleProperty('isShowingSendTestEventModal');
  }

  updateModel = dropTask(async () => {
    return this.send('reloadModel');
  });
}
